module.exports={
    home: {
    	sure:'确定',
        float:{
        	updateLabel:'更新标签:',
	        success:'成功：',
	        fail:'失败：',
	        initMsg:'当前没有正在更新的标签！'
        },
        dialog:{
        	msg:'获取更新标签状态失败！'
        },
        tips:{
            chooseSys: '请联系管理员先选择所需的应用场景'
        }
    }
}


// WEBPACK FOOTER //
// ./src/components/common/lang/zh/Home.js